/* Black Lysted x Cranked Up — interactive pieces (videos, truck dash, record). Vanilla JS, no dependencies. */
(function () {
  'use strict';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function readJSON(root, sel) {
    var el = root.querySelector(sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  var PLAY_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="currentColor"><polygon points="6 3 20 12 6 21 6 3"/></svg>';

  /* ---------------- Videos ---------------- */
  function initVideos(root) {
    var vids = readJSON(root, '[data-blcu-videos-json]') || [];
    if (!vids.length) return;
    var stage = root.querySelector('[data-stage]');
    var note = root.querySelector('[data-note]');
    var thumbs = root.querySelector('[data-thumbs]');
    var current = vids[Math.min(vids.length - 1, Number(root.dataset.start || 0))];
    var playing = false;

    function find(id) { for (var i = 0; i < vids.length; i++) if (vids[i].id === id) return vids[i]; return vids[0]; }

    function render() {
      var v = current;
      if (playing && v.yt) {
        stage.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + encodeURIComponent(v.yt) +
          '?autoplay=1&rel=0&modestbranding=1&playsinline=1" title="' + esc(v.title + ' — ' + v.kind) +
          '" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>';
      } else {
        stage.innerHTML = '<button type="button" class="blcu-stage__btn" data-play>' +
          '<img src="' + esc(v.poster) + '" alt="" loading="lazy">' +
          '<span class="blcu-stage__shade"></span>' +
          '<span class="blcu-corner blcu-corner--tl"></span><span class="blcu-corner blcu-corner--tr"></span><span class="blcu-corner blcu-corner--bl"></span><span class="blcu-corner blcu-corner--br"></span>' +
          '<span class="blcu-stage__kind">' + esc(v.kind) + '</span>' +
          '<span class="blcu-stage__meta"><span class="blcu-stage__title">' + esc(v.title) + '</span><span class="blcu-stage__year">' + esc(v.year) + '</span></span>' +
          '<span class="blcu-stage__play">' + PLAY_SVG + '<span class="sr-only">Play ' + esc(v.title) + '</span></span></button>';
      }
      note.textContent = v.note || '';
      thumbs.innerHTML = vids.map(function (t) {
        return '<button type="button" class="blcu-thumb" data-pick="' + esc(t.id) + '" aria-pressed="' + (t.id === v.id) + '">' +
          '<img src="' + esc(t.poster) + '" alt="" loading="lazy"><span class="blcu-thumb__t">' + esc(t.title) +
          '</span><span class="blcu-thumb__k">' + esc(t.kind) + ' · ' + esc(t.year) + '</span></button>';
      }).join('');
    }

    root.addEventListener('click', function (e) {
      var pick = e.target.closest('[data-pick]');
      if (pick) { current = find(pick.getAttribute('data-pick')); playing = true; render(); return; }
      if (e.target.closest('[data-play]')) { playing = true; render(); }
    });
    root._blcuPlay = function (id) { current = find(id); playing = true; render(); };
    render();
  }

  /* ---------------- Truck dash ---------------- */
  function initDash(root) {
    var cfg = readJSON(root, '[data-blcu-dash-json]');
    if (!cfg || !cfg.stations || !cfg.stations.length) return;
    var S = cfg.stations, L = cfg.links || {};
    var idx = Math.max(0, Math.min(S.length - 1, cfg.start != null ? cfg.start : S.length - 1));
    var view = 'playing';
    var outside = null;
    var screen = root.querySelector('[data-screen]');
    var era = root.querySelector('[data-era]');

    function stationIndex(id) { for (var i = 0; i < S.length; i++) if (S[i].id === id) return i; return -1; }
    function tune(id, v) { var i = stationIndex(id); if (i >= 0) idx = i; view = v || 'playing'; render(true); }
    function nudge(d) { idx = Math.min(S.length - 1, Math.max(0, idx + d)); view = 'playing'; render(true); }
    function playSong() {
      var st = S[idx];
      window.open(st.yt ? 'https://www.youtube.com/watch?v=' + encodeURIComponent(st.yt) : (L.youtube || L.spotify), '_blank', 'noopener,noreferrer');
    }
    function pageVideos() {
      var el = document.querySelector('[data-blcu-videos-json]');
      if (!el) return [];
      try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
    }
    function readTemp() {
      if (!navigator.geolocation) { outside = { error: 1 }; renderStatus(); return; }
      outside = null;
      navigator.geolocation.getCurrentPosition(function (pos) {
        var lat = pos.coords.latitude, lon = pos.coords.longitude;
        fetch('https://api.open-meteo.com/v1/forecast?latitude=' + lat + '&longitude=' + lon + '&current=temperature_2m&temperature_unit=fahrenheit')
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var t = j && j.current && j.current.temperature_2m;
            outside = typeof t === 'number' ? { temp: Math.round(t) } : { error: 1 };
            renderStatus();
          })
          .catch(function () { outside = { error: 1 }; renderStatus(); });
      }, function () { outside = { error: 1 }; renderStatus(); }, { timeout: 8000, maximumAge: 300000 });
    }
    function clock() {
      try { return new Date().toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }); } catch (e) { return '--:--'; }
    }
    function outLabel() { return outside && 'temp' in outside ? outside.temp + '°' : outside && outside.error ? '—' : 'OUT'; }

    function renderStatus() {
      var c = screen.querySelector('[data-clock]'); if (c) c.textContent = clock();
      var o = screen.querySelector('[data-out]'); if (o) o.textContent = outLabel();
    }

    function key(label, act, extra) {
      return '<button type="button" class="blcu-key lbl" data-act="' + act + '"' + (extra || '') + '>' + esc(label) + '</button>';
    }

    function viewHTML() {
      var st = S[idx];
      if (view === 'playing') {
        return '<div class="blcu-play"><div class="blcu-play__grid">' +
          '<div class="blcu-play__col">' + key('FM', 'tune:roll') + key('SXM', 'view:sxm') + key('BL', 'tune:redline') + key('USB', 'view:browse') + '</div>' +
          '<div class="blcu-play__mid"><button type="button" class="blcu-play__art" data-act="play" aria-label="Play ' + esc(st.title) + '"><img src="' + esc(st.art) + '" alt=""></button>' +
          '<p class="blcu-play__call blcu-trunc">' + esc(st.call) + ' <span class="blcu-dim">FM</span></p>' +
          '<p class="blcu-play__sm blcu-trunc blcu-red">Rod Black</p>' +
          '<p class="blcu-play__sm blcu-trunc">' + esc(st.title) + '</p>' +
          '<button type="button" class="blcu-play__over lbl" data-act="tune:' + esc(S[0].id) + '">Start over</button></div>' +
          '<div class="blcu-play__col">' + key('Rod', 'home') + key('Find', 'view:sources') + key('List', 'go:list') + '</div></div>' +
          '<div class="blcu-play__ch"><button type="button" data-act="prev" aria-label="Channel down">‹ CH</button><button type="button" data-act="view:presets">All</button><button type="button" data-act="next" aria-label="Channel up">CH ›</button><button type="button" class="blcu-red" data-act="play">Play</button></div>' +
          '<div class="blcu-presets">' + S.map(function (s) {
            return '<button type="button" data-act="tune:' + esc(s.id) + '" aria-pressed="' + (s.id === st.id) + '"><span class="lbl">' + esc(s.call) + '</span><span class="lbl blcu-trunc">' + esc(s.preset) + '</span></button>';
          }).join('') + '</div></div>';
      }
      if (view === 'sxm') {
        return '<iframe class="blcu-spot" title="Black Lysted on Spotify" src="https://open.spotify.com/embed/artist/' + esc(cfg.spotifyId) + '?utm_source=generator&theme=0" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>';
      }
      if (view === 'sources') {
        return '<ul class="blcu-list">' + S.map(function (s, i) {
          return '<li><button type="button" data-act="tune:' + esc(s.id) + '" class="' + (i === idx ? 'cur' : 'oth') + '"><span>' + esc(s.title) + '</span><span class="lbl">' + esc(s.call) + '</span></button></li>';
        }).join('') + '</ul>';
      }
      if (view === 'presets') {
        return '<ul class="blcu-list">' + S.map(function (s) {
          return '<li><button type="button" data-act="tune:' + esc(s.id) + '"><span>' + esc(s.preset) + '</span><span class="blcu-dim">' + esc(s.call) + '</span></button></li>';
        }).join('') + '</ul>';
      }
      if (view === 'browse') {
        var vids = pageVideos();
        if (!vids.length) return '<div class="blcu-pad"><p class="lbl blcu-dim">No videos on this page.</p></div>';
        return '<ul class="blcu-list">' + vids.map(function (v) {
          return '<li><a href="https://www.youtube.com/watch?v=' + encodeURIComponent(v.yt) + '" target="_blank" rel="noopener noreferrer"><img src="' + esc(v.poster) + '" alt=""><span class="grow"><span class="blcu-trunc" style="display:block">' + esc(v.title) + '</span><span class="lbl blcu-dim" style="display:block">' + esc(v.kind) + '</span></span></a></li>';
        }).join('') + '</ul>';
      }
      if (view === 'settings') {
        return '<div class="blcu-pad"><p class="lbl blcu-dim" style="text-transform:uppercase">On this station</p><ul>' +
          st.notes.map(function (n) { return '<li>' + esc(n) + '</li>'; }).join('') + '</ul>' +
          '<a class="blcu-red" href="' + esc(L.book) + '">Book the band</a><br><a class="blcu-dim" href="' + esc(L.press) + '">Press</a></div>';
      }
      if (view === 'apps') {
        var apps = [['Spotify', L.spotify, 1], ['YouTube', L.youtube, 1], ['Instagram', L.instagram, 1], ['Facebook', L.facebook, 1], ['Cranked Up', L.cranked, 1], ['Press', L.press, 0], ['Merch', L.store, 0]];
        return '<ul class="blcu-list blcu-grid2">' + apps.filter(function (a) { return a[1]; }).map(function (a) {
          return '<li><a href="' + esc(a[1]) + '"' + (a[2] ? ' target="_blank" rel="noopener noreferrer"' : '') + '>' + esc(a[0]) + '</a></li>';
        }).join('') + '</ul>';
      }
      if (view === 'home') {
        return '<div class="blcu-pad"><p class="lbl blcu-dim" style="text-transform:uppercase">Home</p><p style="margin-top:.5rem;font-size:.875rem">' + esc(cfg.homeText) +
          '</p><a class="blcu-red" href="' + esc(L.homeMap) + '" target="_blank" rel="noopener noreferrer">Open Langley</a></div>';
      }
      if (view === 'comfort') {
        var line = S[stationIndex('line')] || S[0];
        return '<div class="blcu-pad"><p class="lbl blcu-dim" style="text-transform:uppercase">I’m Breathing</p><p style="margin-top:.5rem;font-size:.875rem">' + esc(cfg.comfortText) +
          '</p><button type="button" class="blcu-red" data-act="tune:' + esc(line.id) + '">Tune ' + esc(line.call) + '</button></div>';
      }
      return '';
    }

    function dockBtn(label, act, pressed) {
      return '<button type="button" data-act="' + act + '" aria-pressed="' + !!pressed + '">' + esc(label) + '</button>';
    }
    function dockLink(label, href) { return '<a href="' + esc(href) + '">' + esc(label) + '</a>'; }

    function render(animate) {
      var st = S[idx];
      var tabs = [['Sources', 'sources'], ['Playing', 'playing'], ['Browse', 'browse'], ['Settings', 'settings']];
      screen.innerHTML =
        '<div class="blcu-status">' +
          '<button type="button" class="lbl blcu-red" data-act="tune:redline">LIVE</button>' +
          '<button type="button" class="t" data-act="tune:' + esc(S[S.length - 1].id) + '" data-clock>' + esc(clock()) + '</button>' +
          '<button type="button" class="lbl blcu-dim" data-act="temp" data-out>' + esc(outLabel()) + '</button>' +
          '<button type="button" class="lbl" data-act="home" aria-label="Rod">ROD</button>' +
          '<button type="button" class="lbl blcu-red" data-act="tune:' + esc(S[S.length - 1].id) + '">ON</button>' +
        '</div>' +
        '<div class="blcu-tabs">' + tabs.map(function (t) {
          return '<button type="button" class="lbl" data-act="view:' + t[1] + '" aria-pressed="' + (view === t[1]) + '">' + t[0] + '</button>';
        }).join('') + '</div>' +
        '<div class="blcu-view">' + viewHTML() + '</div>' +
        '<div class="blcu-dock">' +
          dockBtn('Home', 'home', view === 'home') + dockBtn('Media', 'view:playing', view === 'playing') +
          dockBtn('Comfort', 'comfort', view === 'comfort') + dockLink('Phone', L.book) +
          dockBtn('Truck', 'tune:roll', st.id === 'roll' && view === 'playing') + dockBtn('Apps', 'view:apps', view === 'apps') + dockLink('Nav', L.shows) +
        '</div>' +
        '<div class="blcu-foot">' +
          '<button type="button" class="lbl" data-act="tune:' + esc(S[S.length - 1].id) + '">FRONT</button>' +
          '<a class="lbl" href="' + esc(L.shows) + '">REAR</a>' +
          '<div class="seek"><button type="button" data-act="prev" aria-label="Seek down">‹</button><button type="button" data-act="next" aria-label="Seek up">›</button></div>' +
          '<button type="button" class="lbl blcu-red" data-act="tune:' + esc(S[S.length - 1].id) + '">NORMAL</button>' +
        '</div>';

      era.innerHTML =
        '<div><p class="blcu-era__call">' + esc(st.call) + '</p><p class="blcu-era__years">' + esc(st.years) + '</p></div>' +
        '<div><p class="blcu-kicker">' + esc(st.kicker) + '</p><h3>' + esc(st.title) + '</h3><p class="blcu-lead" style="max-width:42rem">' + esc(st.body) + '</p>' +
        '<ul class="blcu-chips">' + st.notes.map(function (n) { return '<li>' + esc(n) + '</li>'; }).join('') + '</ul></div>';
      if (animate) { era.classList.remove('blcu-in'); void era.offsetWidth; era.classList.add('blcu-in'); }
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-act]');
      if (!b || !root.contains(b)) return;
      var a = b.getAttribute('data-act');
      if (a.indexOf('tune:') === 0) {
        var id = a.slice(5);
        if (stationIndex(id) < 0) return;
        tune(id, b.hasAttribute('data-comfort') ? 'comfort' : 'playing');
      } else if (a.indexOf('view:') === 0) { view = a.slice(5); render(false); }
      else if (a === 'prev') nudge(-1);
      else if (a === 'next') nudge(1);
      else if (a === 'play') playSong();
      else if (a === 'home') { idx = 0; view = 'home'; render(true); }
      else if (a === 'comfort') { var li = stationIndex('line'); if (li >= 0) idx = li; view = 'comfort'; render(true); }
      else if (a === 'temp') readTemp();
      else if (a === 'go:list') { if (L.list) window.location.href = L.list; }
      else if (a === 'go:shows') { if (L.shows) window.location.href = L.shows; }
    });

    render(false);
    var t = setInterval(renderStatus, 30000);
    root._blcuStop = function () { clearInterval(t); };
  }

  /* ---------------- Record ---------------- */
  function initRecord(root) {
    var stats = root.querySelectorAll('[data-count]');
    var done = false;
    function run() {
      if (done) return; done = true;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      stats.forEach(function (el) {
        var target = Number(el.getAttribute('data-count')) || 0;
        var pre = el.getAttribute('data-prefix') || '', suf = el.getAttribute('data-suffix') || '';
        if (reduce) { el.textContent = pre + target + suf; return; }
        var t0 = performance.now();
        (function step(now) {
          var p = Math.min(1, (now - t0) / 800), eased = 1 - Math.pow(1 - p, 3);
          el.textContent = pre + Math.round(target * eased) + suf;
          if (p < 1) requestAnimationFrame(step);
        })(t0);
      });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0] && en[0].isIntersecting) { run(); io.disconnect(); } }, { threshold: 0.3 });
      io.observe(root);
    } else run();

    var tabs = root.querySelectorAll('[role="tab"]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on);
          var p = root.querySelector('#' + t.getAttribute('aria-controls'));
          if (p) { p.hidden = !on; if (on) { p.classList.remove('blcu-in'); void p.offsetWidth; p.classList.add('blcu-in'); } }
        });
      });
    });
  }

  /* ---------------- Hero "Play Dangerous" ---------------- */
  function initHero(root) {
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-hero-play]');
      if (!b) return;
      var vidRoot = document.querySelector('[data-blcu="videos"]');
      if (vidRoot && vidRoot._blcuPlay) {
        vidRoot._blcuPlay(b.getAttribute('data-hero-play'));
        vidRoot.scrollIntoView({ behavior: 'smooth' });
      } else if (b.dataset.fallback) {
        window.open(b.dataset.fallback, '_blank', 'noopener,noreferrer');
      }
    });
  }

  var INIT = { videos: initVideos, dash: initDash, record: initRecord, hero: initHero };
  function boot(scope) {
    (scope || document).querySelectorAll('[data-blcu]').forEach(function (el) {
      if (el._blcuReady) return;
      var fn = INIT[el.getAttribute('data-blcu')];
      if (fn) { el._blcuReady = true; fn(el); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  // Theme editor: re-init when a section is added or re-rendered.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-blcu]').forEach(function (el) { if (el._blcuStop) el._blcuStop(); });
  });
})();
